import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { OfflineHeadset } from 'src/models';
import { getOfflineHeadsetsAction } from 'src/services/offlineHeadsets';
import { compareString } from '../../helper';

const headsetsEntityAdapter = createEntityAdapter({
  selectId: (headset: OfflineHeadset) => headset.id,
});

export const headsetsSelectors = headsetsEntityAdapter.getSelectors();

const initialState: {
  isPending: boolean | null;
  hasError: boolean;
} = {
  isPending: null,
  hasError: false,
};

const offlineHeadsetsSlice = createSlice({
  name: 'offline_headsets',
  initialState: headsetsEntityAdapter.getInitialState(initialState),
  reducers: {
    clearOfflineHeadsetsState: (state) => {
      state.isPending = null;
      state.hasError = false;
      headsetsEntityAdapter.setAll(state, []);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOfflineHeadsetsAction.pending, (state) => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(
      getOfflineHeadsetsAction.fulfilled,
      (state, { payload }) => {
        state.isPending = false;
        state.hasError = false;
        headsetsEntityAdapter.setAll(
          state,
          payload.sort((a, b) => {
            const byName = compareString(a.companyName, b.companyName);

            if (byName === 0) {
              const dateA = new Date(a.lastActivity).getTime();
              const dateB = new Date(b.lastActivity).getTime();
              return dateA - dateB;
            }

            return byName;
          }),
        );
      },
    );
    builder.addCase(getOfflineHeadsetsAction.rejected, (state) => {
      state.isPending = false;
      state.hasError = true;
    });
  },
});

export const { clearOfflineHeadsetsState } = offlineHeadsetsSlice.actions;

const { reducer } = offlineHeadsetsSlice;

export default reducer;
